import Axios from 'axios';

async function get(url: string, token: string) {
  try {
    const response = await Axios.get(url, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default get;
